import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { CurrencyProvider } from "@/lib/currency";
import Home from "@/pages/Home";
import Compare from "@/pages/Compare";
import AIFinder from "@/pages/AIFinder";
import PremiumDomains from "@/pages/PremiumDomains";
import Pricing from "@/pages/Pricing";
import Blog from "@/pages/Blog";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import SeoPage from "@/pages/SeoPage";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";
import Sitemap from "@/pages/Sitemap";

// All keyword-rich SEO landing pages — handled by SeoPage with slug from pathname.
const SEO_SLUGS = [
  "best-ai-domains",
  "startup-domain-names",
  "cheap-domain-registrars",
  "best-dot-ai-domains",
  "hotel-tech-domains",
  "cheap-domains",
  "cheapest-domain-registration",
  "cheap-domain-and-hosting",
  "buy-domain-cheap",
  "cheap-domain-and-email",
  "cheapest-com-domain",
  "domain-price-comparison",
  "cheap-domain-provider",
  // Brand new long-form SEO posts
  "how-to-transfer-domain",
  "namecheap-vs-godaddy-vs-cloudflare",
  "whois-privacy-explained",
  "renewal-traps-to-avoid",
  "io-vs-com-vs-ai",
  // Inventory + niche keyword landing pages
  "ai-domain-names-for-sale",
  "expiring-domain-names",
  "saas-domains-for-sale",
  "startup-domains-for-sale",
  "cheap-domain-names",
];

function AppRouter() {
  const location = useLocation();
  // Synchronous hash check — must run before any route renders
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/compare" element={<Compare />} />
      <Route path="/ai-finder" element={<AIFinder />} />
      <Route path="/premium-domains" element={<PremiumDomains />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admin" element={<Admin />} />
      {/* Company */}
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      {/* Legal */}
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/sitemap" element={<Sitemap />} />
      {/* SEO long-tail keyword pages */}
      {SEO_SLUGS.map((slug) => (
        <Route key={slug} path={`/${slug}`} element={<SeoPage />} />
      ))}
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <CurrencyProvider>
              <AppRouter />
              <Toaster position="bottom-right" richColors />
            </CurrencyProvider>
          </AuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
